module.exports = __webpack_public_path__ + "img/927.78f08ff1.gif";